module.exports = __webpack_public_path__ + "static/images/dc4e257e8fafd0708f7c7c9120e3c162.png";